// ----------------------------------------------------------------------

import { useQuery, type UseQueryOptions } from '@tanstack/react-query';

import { SearchApi, type IkpuParams, type IkpusParams } from '@/api/domains/search.api';
import { SearchQueryKeys } from '@/api/domains/search.query-keys';

export const useIkpusInfo = (
  params: IkpusParams,
  queryOptions?: Pick<UseQueryOptions, 'enabled' | 'keepPreviousData'>,
) => {
  const { isFetching, data } = useQuery({
    queryKey: SearchQueryKeys.getIkpusInfo(params),
    queryFn: () => SearchApi.fetchIkpusInfo(params),
    staleTime: Infinity,
    ...queryOptions,
  });

  const ikpusInfo = data?.items || [];

  return { isFetching, ikpusInfo };
};

export const useIkpuInfo = (
  params: IkpuParams,
  queryOptions?: Pick<UseQueryOptions, 'enabled' | 'keepPreviousData'>,
) => {
  const { isFetching, data } = useQuery({
    queryKey: SearchQueryKeys.getIkpuInfo(params),
    queryFn: () => SearchApi.fetchIkpuInfo(params),
    staleTime: 0,
    ...queryOptions,
  });

  const ikpuInfo = data?.items[0] || null;

  return { isFetching, ikpuInfo };
};
